import styled from 'styled-components';

export default styled.div`
	display: flex;
	gap: var(--spacing-x-small);
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
	${({$color}) => $color && `color: ${$color};`}
`;
